import React from 'react'

const Contact = () => {
  return (
    <div>
      <h1>contact</h1>
    </div>
  )
}

export default Contact
